import api from "../api/axios";

const BranchService = {
  getAll: async () => {
    const response = await api.get("/Branch");
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/Branch/${id}`);
    return response.data;
  },
  create: async (dto) => {
    const response = await api.post("/Branch", dto);
    return response.data;
  },
  update: async (dto) => {
    const response = await api.put("/Branch", dto);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/Branch/${id}`);
    return response.data;
  },
};

export default BranchService;
